import axios from '@axios'

export function ServiceSettingsChatSpecialist() {
  this.getSettingsChat = () => new Promise((resolve, reject) => {
    axios.get('specialists/settings')
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.updateSettingsChat = (query, data) => new Promise((resolve, reject) => {
    axios.put('specialists/settings', data, { params: query })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.createSettingsChat = data => new Promise((resolve, reject) => {
    axios.post('specialists/settings', data)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
